import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LoadingService } from "src/app/services/loading.service";
import { Router } from '@angular/router';

@Component({
    selector: 'app-private-layout',
    templateUrl: './private-layout.component.html',
    styleUrls: ['./private-layout.component.scss'],
    standalone: false
})
export class PrivateLayoutComponent implements OnInit {
  @BlockUI('componentsPrivateLayout') blockUIglobal: NgBlockUI;
  header = "Mis Solicitudes";
  dataSession = null;
  isPortalClienteRoute = false;

  constructor(public _loading: LoadingService, private router: Router) { }

  ngOnInit() {
    this._loading.setLoadingUI(this.blockUIglobal);
    this.router.events.subscribe(() => {
      this.isPortalClienteRoute = this.router.url.startsWith('/portal-cliente');
    });
    this.isPortalClienteRoute = this.router.url.startsWith('/portal-cliente');
  }
  getDataSession(data) {
    this.dataSession = data;
  }
}
